let config = {};

config['axios'] = {
  timeout: 30000
};

config['api'] = {
  jobMedia: '/me/jobs/:job_id/media',
  photographerMedia: '/me/photographer_media',
  photographerAvailabilities: '/photographer_availabilities',
  payment: '/checkout/pay'
};

config['currency'] = {
  minimumValidPrice: 0,
  maximumValidPrice: 1000000,
  precision: 2
};

export default config;
